import { REVIEWS } from "@/lib/clinic";
import { Star, Quote } from "lucide-react";

function ReviewCard({ r }) {
  return (
    <article
      data-testid={`review-card-${r.name}`}
      className="shrink-0 w-[340px] sm:w-[380px] rounded-3xl bg-white border border-stone-200 p-7 mr-6"
    >
      <Quote className="w-7 h-7 text-[#E08570]" />
      <p className="mt-4 text-stone-700 leading-relaxed text-[15px]">
        {r.text}
      </p>
      <div className="mt-6 flex items-center gap-3 pt-5 border-t border-stone-100">
        <div className="grid place-items-center w-10 h-10 rounded-full bg-[#3A564A] text-[#FAFAF9] font-display font-bold">
          {r.initial}
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-stone-900">{r.name}</p>
          <p className="text-xs text-stone-500">{r.when}</p>
        </div>
        <div className="flex items-center gap-0.5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="w-3 h-3 fill-[#E08570] text-[#E08570]" />
          ))}
        </div>
      </div>
    </article>
  );
}

export default function Reviews() {
  // duplicated for seamless marquee
  const loop = [...REVIEWS, ...REVIEWS];

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-20 sm:py-24 lg:py-32 bg-[#3A564A]/[0.03] border-y border-stone-200/60 overflow-hidden"
    >
      <div className="container mx-auto px-6 sm:px-8 mb-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-[#3A564A]">
              <span className="h-px w-8 bg-[#3A564A]" />
              Real Google reviews
            </span>
            <h2 className="font-display font-bold text-stone-900 text-4xl sm:text-5xl tracking-tight mt-5 leading-[1.05]">
              77 patients. <span className="italic">One perfect score.</span>
            </h2>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-5 h-5 fill-[#E08570] text-[#E08570]"
                />
              ))}
            </div>
            <span className="font-display text-2xl font-bold text-stone-900">
              5.0
            </span>
            <span className="text-stone-500">/ 5</span>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="marquee-pause relative" data-testid="reviews-marquee">
        <div
          aria-hidden
          className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#FAFAF9] to-transparent z-10 pointer-events-none"
        />
        <div
          aria-hidden
          className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#FAFAF9] to-transparent z-10 pointer-events-none"
        />
        <div className="flex animate-marquee w-max">
          {loop.map((r, i) => (
            <ReviewCard key={i} r={r} />
          ))}
        </div>
      </div>

      <div className="container mx-auto px-6 sm:px-8 mt-10 text-center">
        <a
          href="https://www.google.com/maps/search/?api=1&query=Dent+Square+Gomti+Nagar+Lucknow"
          target="_blank"
          rel="noreferrer"
          data-testid="all-reviews-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-[#3A564A] hover:underline underline-offset-4"
        >
          Read all 77 reviews on Google →
        </a>
      </div>
    </section>
  );
}
